import React from 'react'

import GamesGrid from '../../components/GamesGrid'
import { TournamentWithMembership } from '../Tournaments/types/Tournament'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { MINIMAL_GAMES_FOR_TWO_ROWS_VIEW } from './constants'
import ContentWrapper from './styles/ContentWrapper'
import { Wrapper } from './styles/Wrapper'
import { getSlugs } from './utils'

interface Props {
  tournament: TournamentWithMembership
  games: any
  favoriteGames: string[]
}

export default function TournamentCategory({ tournament, games, favoriteGames }: Props) {
  const rows = tournament.games.length >= MINIMAL_GAMES_FOR_TWO_ROWS_VIEW ? 2 : 1
  const slugs = getSlugs(games, tournament.games, favoriteGames)

  return (
    <Wrapper background={tournament.background}>
      <ContentWrapper>
        <Header
          id={tournament.id}
          name={tournament.name}
        />
        <GamesGrid
          games={slugs}
          rows={rows}
        />
        <Footer
          id={tournament.id}
          finishDate={tournament.finishDate}
        />
      </ContentWrapper>
    </Wrapper>
  )
}
